// extracted by mini-css-extract-plugin
export default {"grid":"grid___PQP_e","error":"error___CnXTi"};